import React from 'react';
import { motion } from 'framer-motion';
import { Award, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';

interface HeroContentProps {
  currentSlide: number;
  slides: {
    title: string;
    description: string;
  }[];
}

const HeroContent: React.FC<HeroContentProps> = ({ currentSlide, slides }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className="max-w-2xl text-white pt-16"
    >
      <motion.div
        key={currentSlide}
        initial={{ opacity: 0, x: 100 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -100 }}
        transition={{ duration: 1, ease: "easeInOut" }}
      >
        <h1 className="text-3xl md:text-5xl font-medium mb-6">
          {slides[currentSlide].title}
        </h1>
        <p className="text-lg md:text-xl mb-8">
          {slides[currentSlide].description}
        </p>
      </motion.div>
      
      <div className="flex flex-col sm:flex-row gap-4 mb-8">
        <motion.a
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          href="tel:0789307500"
          className="btn-primary text-lg flex items-center justify-center"
        >
          <Phone className="h-5 w-5 mr-2" />
          Nous contacter
        </motion.a>
        <Link
          to="/services"
          className="btn bg-white text-dk-blue hover:bg-gray-100 text-lg text-center"
        >
          Nos services
        </Link>
      </div>
      
      <motion.div
        whileHover={{ scale: 1.02 }}
        transition={{ type: "spring", stiffness: 400, damping: 10 }}
      >
        <Link to="/services" className="flex items-center bg-white/20 backdrop-blur-sm rounded-lg p-3 hover:bg-white/30 transition-colors max-w-md">
          <Award className="h-6 w-6 text-white mr-3 flex-shrink-0" />
          <div>
            <span className="font-semibold">Diagnostiqueur certifié</span>
            <p className="text-sm">Tous les diagnostics obligatoires pour votre bien immobilier</p>
          </div>
        </Link>
      </motion.div>
    </motion.div>
  );
};

export default HeroContent;